const initialCity = {
    cities: [],
    citiesmessages : {},
    companies: [],
    designations : [],
    creditdaysdropdowns : [],

};

const cityReducer = (city = initialCity, action) => {
    switch (action.type) {
        
        case 'GET_CITY':
        return {
            ...city, cities: action.payload.data
        };
        case 'ADD_CITY':
        return {
            ...city, citiesmessages: action.payload.data
        };
        case 'UPDATE_CITY':
        return {
            ...city, citiesmessages: action.payload.data
        };
        case 'GET_COMPANY':
        return {
            ...city, companies: action.payload.data
        };
        case 'GET_DESIGNATION':
        return {
            ...city, designations: action.payload.data
        };
        case 'GET_CREDITDAYS_DROPDOWN':
        return {
            ...city, creditdaysdropdowns: action.payload.data
        };
        default:
            return city;
    }
}
export default cityReducer;